(() => {
  document.querySelectorAll('[data-pbh-publications-toggle]').forEach((button) => {
    if (button.dataset.initialised === 'true') return;
    button.dataset.initialised = 'true';

    const container = button.closest(
      '.science-publications-capture__inner, .biofarm-publications-capture__inner'
    );
    const expand = container?.querySelector('[data-pbh-publications-expand]');
    if (!expand) return;

    const seeFull = button.textContent?.trim() || '';
    const seeLess = button.dataset.seeLess || 'See less';

    const setExpanded = (isExpanded) => {
      button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      expand.setAttribute('aria-hidden', isExpanded ? 'false' : 'true');
      expand.classList.toggle('is-expanded', isExpanded);

      if (isExpanded) {
        expand.removeAttribute('inert');
      } else {
        expand.setAttribute('inert', '');
      }

      button.textContent = isExpanded ? seeLess : seeFull;
    };

    setExpanded(false);

    button.addEventListener('click', () => {
      const isExpanded = button.getAttribute('aria-expanded') === 'true';
      setExpanded(!isExpanded);
    });
  });
})();
